/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext, useState } from 'react'

interface EstoqueFilterContextType {
  year: number
  setYear: (y: number) => void
  month: number
  setMonth: (m: number) => void
  distributorIds: (string | number)[]
  setDistributorIds: (ids: (string | number)[]) => void
  toggleDistributor: (id: string | number) => void
  selectAllDistributors: (ids: (string | number)[]) => void
  clearDistributors: () => void
  regional: string | null
  setRegional: (r: string | null) => void
  gestor: string | null
  setGestor: (g: string | null) => void
  marca: string | null
  setMarca: (m: string | null) => void
  categoria: string | null
  setCategoria: (c: string | null) => void
  prevMonth: () => void
  nextMonth: () => void
  resetFilters: () => void
}

const EstoqueFilterContext = createContext<EstoqueFilterContextType | undefined>(undefined)

export const EstoqueFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const now = new Date()
  const [year, setYear] = useState<number>(now.getFullYear())
  const [month, setMonth] = useState<number>(now.getMonth())
  const [distributorIds, setDistributorIds] = useState<(string | number)[]>([])
  const [regional, setRegional] = useState<string | null>(null)
  const [gestor, setGestor] = useState<string | null>(null)
  const [marca, setMarca] = useState<string | null>(null)
  const [categoria, setCategoria] = useState<string | null>(null)

  const toggleDistributor = (id: string | number) => {
    setDistributorIds((prev) => {
      const exists = prev.some((item) => String(item) === String(id))
      if (exists) {
        return prev.filter((item) => String(item) !== String(id))
      } else {
        return [...prev, id]
      }
    })
  }

  const selectAllDistributors = (ids: (string | number)[]) => {
    setDistributorIds(ids)
  }

  const clearDistributors = () => {
    setDistributorIds([])
  }

  const prevMonth = () => {
    if (month === 0) {
      setMonth(11)
      setYear((y) => y - 1)
    } else {
      setMonth((m) => m - 1)
    }
  }

  const nextMonth = () => {
    if (month === 11) {
      setMonth(0)
      setYear((y) => y + 1)
    } else {
      setMonth((m) => m + 1)
    }
  }

  const resetFilters = () => {
    const current = new Date()
    setYear(current.getFullYear())
    setMonth(current.getMonth())
    setDistributorIds([])
    setRegional(null)
    setGestor(null)
    setMarca(null)
    setCategoria(null)
  }

  return (
    <EstoqueFilterContext.Provider
      value={{
        year,
        setYear,
        month,
        setMonth,
        distributorIds,
        setDistributorIds,
        toggleDistributor,
        selectAllDistributors,
        clearDistributors,
        regional,
        setRegional,
        gestor,
        setGestor,
        marca,
        setMarca,
        categoria,
        setCategoria,
        prevMonth,
        nextMonth,
        resetFilters,
      }}
    >
      {children}
    </EstoqueFilterContext.Provider>
  )
}

export const useEstoqueFilter = (): EstoqueFilterContextType => {
  const ctx = useContext(EstoqueFilterContext)
  if (!ctx) throw new Error('useEstoqueFilter deve ser utilizado dentro de EstoqueFilterProvider')
  return ctx
}

